<template>

    <section>
        <!-- ここから -->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            Heading
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <h1 class="heading_page-title flex _y-center">
            <div class="main"><span>メンバー招待</span></div>
        </h1><!--/.heading_page-title-->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            TeamInvitation
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="team_component form_admin-container">

            <div class="md_common-bl _padding-add">
                <div class="inner">

                    <!-- Title -->
                    <div class="md_common-bl-title-wrap">
                        <h3 class="title"><span class="md_text-bold _link-color">ブランド名</span>にメンバーを招待</h3>
                        <p>招待するメンバーの権限を選択してください。</p>
                    </div>

                    <!-- InputGroup -->
                    <div class="input-group">

                        <!-- RadioItem -->
                        <div class="form_item-text form_radio-text">
                            <input type="radio" name="invitation-radio1" id="invitation-radio1-1" checked>
                            <label for="invitation-radio1-1">
                                <div class="mark"></div>
                                <span>管理者</span>
                                <p class="sup">最上位の権限です。メンバーの招待、プランのアップグレード等全ての操作を行えます。※ 管理者は運営会社に2名です。管理者の管理画面より権限の譲渡が可能です。</p>
                            </label>
                        </div>

                        <!-- RadioItem -->
                        <div class="form_item-text form_radio-text">
                            <input type="radio" name="invitation-radio1" id="invitation-radio1-2">
                            <label for="invitation-radio1-2">
                                <div class="mark"></div>
                                <span>一般</span>
                                <p class="sup">基本的な操作が可能です。無料ブランドの追加を行えます。</p>
                            </label>
                        </div>

                    </div><!--/.input-group-->

                    <!-- InputGroup -->
                    <div class="input-group">

                        <!-- メールアドレス -->
                        <div class="form_item-text form_text">
                            <div class="input-row">
                                <input type="email" id="invitation-email" inputmode="email">
                            </div>
                            <label for="invitation-email">
                                <span>メールアドレス</span>
                            </label>
                            <p class="sup">招待するメンバーのメールアドレスを入力してください。</p>
                        </div>

                    </div><!--/.input-group-->

                    <!-- BtnLinkWrap -->
                    <div class="btn_link-wrap">

                        <!--LinkBtn - キャンセル -->
                        <Link class="btn_link _cancel md_icon-text" :href="route('admin.brand.dm.list')">
                            <div class="inner">
                                <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                            </div>
                        </Link>

                        <!--LinkBtn - 決定アイコン -->
                        <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                            <div class="inner">
                                <span><div class="icon"><SvgIconCheck /></div>招待を送信する</span>
                            </div>
                        </Link>

                    </div><!-- /BtnLinkWrap -->

                </div>
            </div>

        </div><!-- /.team_component -->

        <!-- ここまで -->
    </section>

</template>


<script>
    import { Link } from '@inertiajs/inertia-vue3'

    //Svg
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconSend from '@/components/EndUser/svg/SvgIconSend'

    export default {
        components: {
            "Link": Link,
            //Svg
            SvgIconEdit,
            SvgIconCancel,
            SvgIconCheck,
            SvgIconSend,
        },
    }
</script>
